import React from 'react';
import { useSelector } from 'react-redux';
import TrailDashboard from '../TrailDashboard';
import MessageTemplates from '../MessageTemplates';
import WCAMessageTemplates from '../WCA/WCAMessageTemplate';

const CampaignTemplate = () => {
  const { userSub, companyConfigData } = useSelector((state) => state.authenticate);
  if (!userSub?.isUserSub) {
    return <TrailDashboard />;
  }

  return companyConfigData?.wabaPartner === 'skalebot' ? (
    <WCAMessageTemplates />
  ) : (
    <MessageTemplates />
  );
};

export default CampaignTemplate;
